import logo from './logo.svg';
import intro from './image.png'
import './App.css';

import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const styles = {
  container: {
    padding: 0,
    margin: 0,
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    overflowX: "hidden",
    position: "relative"
  },
  mainContent: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    minHeight: "100vh",
    maxWidth: "800px",
    margin: "0 auto",
    backgroundColor: "white",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    boxSizing: "border-box",
    overflowY: "auto",
    position: "relative"
  },
  progressWrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    padding: "20px",
    maxWidth: "800px",
    margin: "0 auto",
    pointerEvents: "none"
  },
  progressContainer: {
    width: "100%",
    height: "6px",
    backgroundColor: "#f0f0f0",
    borderRadius: "3px",
    overflow: "hidden",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#fe3c00",
    borderRadius: "3px"
  },
  questionContainer: {
    width: "100%",
    padding: "20px",
    marginBottom: "20px",
    textAlign: "center",
    boxSizing: "border-box"
  },
  question: {
    fontSize: "clamp(24px, 6vw, 36px)",
    fontWeight: "700",
    color: "#333",
    marginBottom: "20px",
    padding: "0 15px",
    wordWrap: "break-word",
    fontFamily: "'Signika', sans-serif",
    letterSpacing: "0.5px",
    lineHeight: "1.3",
    textShadow: "0 1px 2px rgba(0,0,0,0.1)"
  },
  hint: {
    fontSize: "clamp(16px, 4vw, 18px)",
    color: "#666",
    marginBottom: "30px",
    padding: "0 15px",
    fontStyle: "italic",
    fontFamily: "'Signika', sans-serif",
    lineHeight: "1.4"
  },
  answersContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "0px 0px",
    boxSizing: "border-box"
  },
  button: {
    width: "100%",
    backgroundColor: "#fe3c00",
    border: "none",
    padding: "16px 24px",
    borderRadius: "12px",
    color: "white",
    fontSize: "clamp(14px, 4vw, 16px)",
    fontWeight: "600",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 4px rgba(254, 60, 0, 0.2)",
    boxSizing: "border-box",
    wordWrap: "break-word",
    whiteSpace: "normal"
  },
  endScreen: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    minHeight: "100vh",
    padding: "20px",
    paddingTop: "60px",
    textAlign: "center",
    boxSizing: "border-box",
    overflowY: "auto"
  },
  endTitle: {
    fontSize: "clamp(24px, 6vw, 32px)",
    fontWeight: "700",
    color: "#333",
    marginBottom: "20px",
    fontFamily: "'Signika', sans-serif",
    letterSpacing: "0.5px"
  },
  introScreen: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "40px 20px",
    backgroundImage: `linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.7) 0%, 
      rgba(0, 0, 0, 0.8) 50%, 
      rgba(0, 0, 0, 0.9) 100%), 
      url(${intro})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxSizing: "border-box",
    position: "relative",
    overflow: "hidden"
  },
  introContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    textAlign: "center",
    marginTop: "auto",
    marginBottom: "auto",
    zIndex: 1,
    width: "100%",
    maxWidth: "800px",
    padding: "0 20px"
  },
  introTitle: {
    fontSize: "clamp(24px, 8vw, 48px)",
    fontWeight: "700",
    color: "white",
    margin: 0,
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
    fontFamily: "'Signika', sans-serif",
    letterSpacing: "0.5px",
    lineHeight: "1.2"
  },
  introSubtitle: {
    fontSize: "clamp(16px, 4vw, 20px)",
    color: "rgba(255, 255, 255, 0.9)",
    maxWidth: "600px",
    lineHeight: 1.5,
    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.3)",
    fontFamily: "'Signika', sans-serif",
    margin: "0 auto"
  },
  startButton: {
    backgroundColor: "#fe3c00",
    color: "white",
    border: "none",
    padding: "20px 40px",
    borderRadius: "12px",
    fontSize: "20px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 8px rgba(254, 60, 0, 0.2)",
    transition: "all 0.2s ease",
    marginBottom: "40px",
    zIndex: 1,
    fontFamily: "'Signika', sans-serif",
    minWidth: "200px"
  }
}

const pageVariants = {
  initial: {
    opacity: 0,
    y: 30,
    scale: 0.98
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  },
  out: {
    opacity: 0,
    y: -30,
    scale: 0.98,
    transition: {
      duration: 0.2,
      ease: "easeIn"
    }
  }
};

const buttonVariants = {
  initial: { 
    scale: 1,
    y: 0
  },
  hover: { 
    scale: 1.02,
    y: -2,
    backgroundColor: "#e63500",
    boxShadow: "0 4px 8px rgba(254, 60, 0, 0.3)"
  },
  tap: { 
    scale: 0.95,
    y: 2,
    backgroundColor: "#d32f00",
    boxShadow: "0 2px 4px rgba(254, 60, 0, 0.2)"
  }
};

const buttonTransition = {
  type: "spring",
  stiffness: 400,
  damping: 17,
  mass: 0.8
};

const progressVariants = {
  initial: { width: "0%" },
  animate: (progress) => ({
    width: `${progress}%`,
    transition: {
      duration: 1.5,
      ease: [0.4, 0, 0.2, 1], // Нелинейная анимация
      delay: 0.2
    }
  })
};

const introVariants = {
  initial: { 
    opacity: 0,
    y: 20
  },
  animate: { 
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut"
    }
  },
  exit: { 
    opacity: 0,
    scale: 1.1,
    filter: "brightness(2)",
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

const introItemVariants = {
  initial: { 
    opacity: 0,
    y: 10
  },
  animate: { 
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  }
};

const overlayVariants = {
  initial: { 
    scaleY: 0,
    transformOrigin: "top"
  },
  animate: {
    scaleY: 1,
    transition: {
      duration: 0.4,
      ease: "easeInOut"
    }
  }
};

const flashVariants = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: [0, 1, 0],
    transition: {
      duration: 0.2,
      times: [0, 0.5, 1],
      ease: "easeInOut"
    }
  }
};

function App() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [frames, _] = useState([
    {
      qestion: "What's your preferred position on the field?",
      hint: "Think about where you feel most comfortable and effective during the game",
      answers: [
        {
          text: "Forward/Striker",
          id: 1
        },
        {
          text: "Midfielder",
          id: 2
        },
        {
          text: "Defender",
          id: 3
        },
        {
          text: "Goalkeeper",
          id: 4
        }
      ]
    },
    {
      qestion: "How would you describe your playing style?",
      hint: "Consider your natural approach to the game - are you more aggressive or strategic?",
      answers: [
        {
          text: "Aggressive and direct",
          id: 1
        },
        {
          text: "Technical and creative",
          id: 2
        },
        {
          text: "Strategic and calm",
          id: 3
        },
        {
          text: "Defensive and reliable",
          id: 4
        }
      ]
    },
    {
      qestion: "What's your preferred foot?",
      hint: "Which foot do you naturally use for shooting and passing?",
      answers: [
        {
          text: "Right foot",
          id: 1
        },
        {
          text: "Left foot",
          id: 2
        },
        {
          text: "Both feet",
          id: 3
        }
      ]
    },
    {
      qestion: "How do you handle pressure?",
      hint: "Think about your reaction in crucial moments of the game",
      answers: [
        {
          text: "I thrive under pressure",
          id: 1
        },
        {
          text: "I stay calm and focused",
          id: 2
        },
        {
          text: "I prefer to avoid high-pressure situations",
          id: 3
        }
      ]
    },
    {
      qestion: "What's your leadership style?",
      hint: "How do you naturally lead or support your team?",
      answers: [
        {
          text: "Lead by example",
          id: 1
        },
        {
          text: "Vocal leader",
          id: 2
        },
        {
          text: "Supportive teammate",
          id: 3
        },
        {
          text: "Quiet professional",
          id: 4
        }
      ]
    },
    {
      qestion: "What's your preferred way to score?",
      hint: "Think about your favorite type of goals or assists",
      answers: [
        {
          text: "Powerful shots",
          id: 1
        },
        {
          text: "Technical finesse",
          id: 2
        },
        {
          text: "Headers",
          id: 3
        },
        {
          text: "I prefer to assist",
          id: 4
        }
      ]
    },
    {
      qestion: "How do you prepare for big matches?",
      hint: "What's your routine before important games?",
      answers: [
        {
          text: "Intense training and visualization",
          id: 1
        },
        {
          text: "Relaxed and focused on tactics",
          id: 2
        },
        {
          text: "Team bonding and strategy",
          id: 3
        }
      ]
    },
    {
      qestion: "What's your favorite type of play?",
      hint: "Which style of football do you enjoy watching and playing the most?",
      answers: [
        {
          text: "Counter-attacking",
          id: 1
        },
        {
          text: "Possession-based",
          id: 2
        },
        {
          text: "Direct and physical",
          id: 3
        },
        {
          text: "Defensive and organized",
          id: 4
        }
      ]
    },
    {
      qestion: "How do you react to mistakes?",
      hint: "What's your immediate reaction when you make a mistake during the game?",
      answers: [
        {
          text: "Learn and move on quickly",
          id: 1
        },
        {
          text: "Analyze and improve",
          id: 2
        },
        {
          text: "Get motivated to prove myself",
          id: 3
        },
        {
          text: "Focus on the next play",
          id: 4
        }
      ]
    },
    {
      qestion: "What's your preferred training focus?",
      hint: "Which aspect of your game do you enjoy improving the most?",
      answers: [
        {
          text: "Technical skills",
          id: 1
        },
        {
          text: "Physical fitness",
          id: 2
        },
        {
          text: "Tactical understanding",
          id: 3
        },
        {
          text: "Mental preparation",
          id: 4
        }
      ]
    },
    {
      qestion: "How do you handle criticism?",
      hint: "How do you respond when receiving feedback from coaches or teammates?",
      answers: [
        {
          text: "Use it as motivation",
          id: 1
        },
        {
          text: "Analyze and improve",
          id: 2
        },
        {
          text: "Stay confident in my abilities",
          id: 3
        },
        {
          text: "Discuss with coaches",
          id: 4
        }
      ]
    },
    {
      qestion: "What's your preferred weather condition?",
      hint: "Which weather conditions make you feel most comfortable on the field?",
      answers: [
        {
          text: "Sunny and warm",
          id: 1
        },
        {
          text: "Rainy and wet",
          id: 2
        },
        {
          text: "Cold and crisp",
          id: 3
        },
        {
          text: "Doesn't matter",
          id: 4
        }
      ]
    }
  ])

  const [currentFrame, setCurrentFrame] = useState(0)
  const [isEnd, setIsEnd] = useState(false)
  const [direction, setDirection] = useState(1)
  const [isIntro, setIsIntro] = useState(true)
  const [isTransitioning, setIsTransitioning] = useState(false);

  const progress = ((currentFrame + 1) / frames.length) * 100

  const [scores, setScores] = useState({
    striker: 0,
    midfielder: 0,
    defender: 0,
    goalkeeper: 0,
    winger: 0,
    playmaker: 0,
    boxToBox: 0,
    sweeper: 0
  })

  const calculateScores = (questionIndex, answerId) => {
    const newScores = { ...scores }
    
    switch(questionIndex) {
      case 0: // Position
        if (answerId === 1) {
          newScores.striker += 2
          newScores.winger += 1
        }
        else if (answerId === 2) {
          newScores.midfielder += 1
          newScores.playmaker += 1
          newScores.boxToBox += 1
        }
        else if (answerId === 3) {
          newScores.defender += 1
          newScores.sweeper += 1
        }
        else if (answerId === 4) newScores.goalkeeper += 2
        break
      case 1: // Playing style
        if (answerId === 1) {
          newScores.striker += 1
          newScores.winger += 1
        }
        else if (answerId === 2) {
          newScores.playmaker += 1.5
          newScores.midfielder += 0.5
        }
        else if (answerId === 3) {
          newScores.defender += 1
          newScores.sweeper += 1
        }
        else if (answerId === 4) {
          newScores.goalkeeper += 1
          newScores.boxToBox += 1
        }
        break
      case 2: // Preferred foot
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.playmaker += 0.5
          newScores.midfielder += 0.5
        }
        else if (answerId === 3) {
          newScores.boxToBox += 0.5
          newScores.sweeper += 0.5
        }
        break
      case 3: // Pressure handling
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.goalkeeper += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.midfielder += 0.5
          newScores.defender += 0.5
          newScores.playmaker += 0.5
        }
        else if (answerId === 3) {
          newScores.sweeper += 0.5
          newScores.boxToBox += 0.5
        }
        break
      case 4: // Leadership
        if (answerId === 1) {
          newScores.defender += 0.5
          newScores.sweeper += 0.5
        }
        else if (answerId === 2) {
          newScores.goalkeeper += 0.5
          newScores.playmaker += 0.5
        }
        else if (answerId === 3) {
          newScores.midfielder += 0.5
          newScores.boxToBox += 0.5
        }
        else if (answerId === 4) {
          newScores.striker += 0.5
          newScores.winger += 0.5
        }
        break
      case 5: // Scoring preference
        if (answerId === 1) {
          newScores.striker += 1
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.playmaker += 1
          newScores.midfielder += 0.5
        }
        else if (answerId === 3) {
          newScores.defender += 0.5
          newScores.sweeper += 0.5
        }
        else if (answerId === 4) {
          newScores.boxToBox += 0.5
          newScores.midfielder += 0.5
        }
        break
      case 6: // Match preparation
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.playmaker += 0.5
          newScores.midfielder += 0.5
        }
        else if (answerId === 3) {
          newScores.defender += 0.5
          newScores.sweeper += 0.5
          newScores.boxToBox += 0.5
        }
        break
      case 7: // Play type
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.playmaker += 0.5
          newScores.midfielder += 0.5
        }
        else if (answerId === 3) {
          newScores.defender += 0.5
          newScores.sweeper += 0.5
        }
        else if (answerId === 4) {
          newScores.boxToBox += 0.5
          newScores.goalkeeper += 0.5
        }
        break
      case 8: // React to mistakes
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.goalkeeper += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.midfielder += 0.5
          newScores.defender += 0.5
          newScores.playmaker += 0.5
        }
        else if (answerId === 3) {
          newScores.sweeper += 0.5
          newScores.boxToBox += 0.5
        }
        break
      case 9: // Preferred training focus
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.playmaker += 0.5
          newScores.midfielder += 0.5
        }
        else if (answerId === 3) {
          newScores.defender += 0.5
          newScores.sweeper += 0.5
        }
        break
      case 10: // Handle criticism
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.goalkeeper += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.midfielder += 0.5
          newScores.defender += 0.5
          newScores.playmaker += 0.5
        }
        else if (answerId === 3) {
          newScores.sweeper += 0.5
          newScores.boxToBox += 0.5
        }
        break
      case 11: // Preferred weather condition
        if (answerId === 1) {
          newScores.striker += 0.5
          newScores.winger += 0.5
        }
        else if (answerId === 2) {
          newScores.playmaker += 0.5
          newScores.midfielder += 0.5
        }
        else if (answerId === 3) {
          newScores.defender += 0.5
          newScores.sweeper += 0.5
        }
        break
    }
    
    return newScores
  }

  const playerProfiles = {
    striker: {
      name: "Lionel Messi",
      description: "You are a football genius! Like Lionel Messi, you possess incredible technique, vision, and the ability to score beautiful goals.",
      image: "https://example.com/messi.jpg"
    },
    midfielder: {
      name: "Kevin De Bruyne",
      description: "You are a creative playmaker! Like Kevin De Bruyne, you have exceptional vision and the ability to create chances for your teammates.",
      image: "https://example.com/debruyne.jpg"
    },
    defender: {
      name: "Sergio Ramos",
      description: "You are a fighter! Like Sergio Ramos, you have a leader's character and are ready to fight for victory until the end.",
      image: "https://example.com/ramos.jpg"
    },
    goalkeeper: {
      name: "Alisson Becker",
      description: "You are a reliable team pillar! Like Alisson, you are always ready to help and save the situation.",
      image: "https://example.com/alisson.jpg"
    },
    winger: {
      name: "Kylian Mbappé",
      description: "You are a lightning-fast winger! Like Mbappé, you combine incredible speed with clinical finishing.",
      image: "https://example.com/mbappe.jpg"
    },
    playmaker: {
      name: "Luka Modrić",
      description: "You are a midfield maestro! Like Modrić, you control the game's tempo and create opportunities with your vision.",
      image: "https://example.com/modric.jpg"
    },
    boxToBox: {
      name: "N'Golo Kanté",
      description: "You are an engine of the team! Like Kanté, you cover every blade of grass and never stop running.",
      image: "https://example.com/kante.jpg"
    },
    sweeper: {
      name: "Virgil van Dijk",
      description: "You are a defensive rock! Like Van Dijk, you read the game perfectly and rarely make mistakes.",
      image: "https://example.com/vandijk.jpg"
    }
  }

  const [showAllResults, setShowAllResults] = useState(false)

  useEffect(() => {
    const img = new Image();
    img.src = intro;
    img.onload = () => {
      setImageLoaded(true);
    };
  }, []);

  const introScreenStyle = {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "40px 20px",
    background: imageLoaded 
      ? `linear-gradient(to bottom, 
          rgba(0, 0, 0, 0.7) 0%, 
          rgba(0, 0, 0, 0.8) 50%, 
          rgba(0, 0, 0, 0.9) 100%),
          url(${intro})`
      : `linear-gradient(45deg, #1a1a1a, #2a2a2a)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    boxSizing: "border-box",
    position: "relative",
    transition: "background 0.5s ease"
  };

  const handleButtonClick = (index) => {
    const newScores = calculateScores(currentFrame, frames[currentFrame].answers[index].id)
    setScores(newScores)
    
    if (currentFrame === frames.length - 1) {
      setIsEnd(true)
    } else {
      setDirection(1)
      setCurrentFrame(currentFrame + 1)
    }
  }

  const handleStart = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setIsIntro(false);
      setIsTransitioning(false);
    }, 400);
  }

  const getResultsWithPercentages = () => {
    const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);
    const results = Object.entries(scores).map(([role, score]) => ({
      role,
      percentage: Math.round((score / totalScore) * 100),
      ...playerProfiles[role]
    }));
    
    return results.sort((a, b) => b.percentage - a.percentage);
  }

  return (
    <div style={styles.container}>
      <AnimatePresence mode="wait">
        {isIntro ? (
          <motion.div
            key="intro"
            style={{
              ...styles.introScreen,
              background: `linear-gradient(to bottom, 
                rgba(0, 0, 0, 0.7) 0%, 
                rgba(0, 0, 0, 0.8) 50%, 
                rgba(0, 0, 0, 0.9) 100%), 
                url(${intro})`
            }}
            variants={introVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <motion.div 
              style={styles.introContent}
              variants={introVariants}
            >
              <motion.h1 
                style={styles.introTitle}
                className="intro-title"
                variants={introItemVariants}
              >
                Which Football Player Are You?
              </motion.h1>
              <motion.p 
                style={styles.introSubtitle}
                variants={introItemVariants}
              >
                Answer a few questions and discover which football star matches your personality and playing style!
              </motion.p>
            </motion.div>
            <motion.button
              style={styles.startButton}
              onClick={handleStart}
              variants={introItemVariants}
              whileHover={{ 
                scale: 1.05,
                backgroundColor: "#e63500",
                boxShadow: "0 6px 12px rgba(254, 60, 0, 0.3)"
              }}
              whileTap={{ scale: 0.95 }}
            >
              Start Quiz
            </motion.button>
            {isTransitioning && (
              <>
                <motion.div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "#fff",
                    zIndex: 100
                  }}
                  variants={flashVariants}
                  initial="initial"
                  animate="animate"
                />
                <motion.div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "#fe3c00",
                    zIndex: 99
                  }}
                  variants={overlayVariants}
                  initial="initial"
                  animate="animate"
                />
              </>
            )}
          </motion.div>
        ) : isEnd ? (
          <motion.div 
            key="end"
            style={{
              ...styles.mainContent,
              justifyContent: "center",
              alignItems: "center"
            }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div 
              style={styles.endScreen}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.3 }}
            >
              <motion.h1 
                style={styles.endTitle}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.3 }}
              >
                Your Result
              </motion.h1>
              
              <motion.div
                style={{
                  width: "100%",
                  maxWidth: "600px",
                  margin: "30px 0"
                }}
              >
                {getResultsWithPercentages()
                  .slice(0, showAllResults ? undefined : 4)
                  .map((result, index) => (
                  <motion.div
                    key={result.role}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "15px",
                      padding: "10px",
                      backgroundColor: index === 0 ? "rgba(254, 60, 0, 0.1)" : "transparent",
                      borderRadius: "8px"
                    }}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.6 + index * 0.1, duration: 0.3 }}
                  >
                    <motion.div
                      style={{
                        flex: 1,
                        textAlign: "left",
                        fontSize: "18px",
                        fontWeight: index === 0 ? "600" : "400",
                        color: index === 0 ? "#fe3c00" : "#333"
                      }}
                    >
                      {result.name}
                    </motion.div>
                    <motion.div
                      style={{
                        width: "100px",
                        height: "6px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "3px",
                        overflow: "hidden",
                        margin: "0 15px"
                      }}
                    >
                      <motion.div
                        style={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: index === 0 ? "#fe3c00" : "#999"
                        }}
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: result.percentage / 100 }}
                        transition={{ delay: 0.8 + index * 0.1, duration: 0.5 }}
                      />
                    </motion.div>
                    <motion.div
                      style={{
                        width: "60px",
                        textAlign: "right",
                        fontSize: "16px",
                        fontWeight: index === 0 ? "600" : "400",
                        color: index === 0 ? "#fe3c00" : "#666"
                      }}
                    >
                      {result.percentage}%
                    </motion.div>
                  </motion.div>
                ))}
              </motion.div>

              {!showAllResults && (
                <motion.button
                  style={{
                    ...styles.button,
                    backgroundColor: "transparent",
                    color: "#fe3c00",
                    border: "2px solid #fe3c00",
                    marginBottom: "20px"
                  }}
                  onClick={() => setShowAllResults(true)}
                  whileHover={{ scale: 1.05, backgroundColor: "rgba(254, 60, 0, 0.1)" }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 1.1, duration: 0.3 }}
                >
                  Show All Results
                </motion.button>
              )}

              <motion.p
                style={{
                  fontSize: "18px",
                  lineHeight: 1.6,
                  color: "#666",
                  maxWidth: "600px",
                  textAlign: "center",
                  margin: "20px 0 40px"
                }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2, duration: 0.3 }}
              >
                {getResultsWithPercentages()[0].description}
              </motion.p>

              <motion.button
                style={{
                  ...styles.button,
                  marginTop: "30px"
                }}
                onClick={() => {
                  setCurrentFrame(0)
                  setScores({
                    striker: 0,
                    midfielder: 0,
                    defender: 0,
                    goalkeeper: 0,
                    winger: 0,
                    playmaker: 0,
                    boxToBox: 0,
                    sweeper: 0
                  })
                  setShowAllResults(false)
                  setIsEnd(false)
                }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.4, duration: 0.3 }}
              >
                Take Quiz Again
              </motion.button>
            </motion.div>
          </motion.div>
        ) : (
          <motion.div
            key="quiz"
            style={styles.mainContent}
            variants={pageVariants}
            initial="initial"
            animate="in"
            exit="out"
          >
            <motion.div 
              style={styles.progressWrapper}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div style={styles.progressContainer}>
                <motion.div
                  style={styles.progressBar}
                  variants={progressVariants}
                  initial="initial"
                  animate="animate"
                  custom={progress}
                />
              </div>
            </motion.div>
            <motion.div 
              style={styles.questionContainer}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.1 }}
            >
              <h2 style={styles.question}>{frames[currentFrame].qestion}</h2>
              <p style={styles.hint}>{frames[currentFrame].hint}</p>
            </motion.div>
            <motion.div 
              style={styles.answersContainer}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.2 }}
            >
              {frames[currentFrame].answers.map((button, index) => (
                <motion.button 
                  key={index}
                  style={styles.button}
                  onClick={() => handleButtonClick(index)}
                  variants={buttonVariants}
                  initial="initial"
                  whileHover="hover"
                  whileTap="tap"
                  transition={{ duration: 0.2 }}
                  custom={index}
                >
                  {button.text}
                </motion.button>
              ))}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
